// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1w7eX","notes":"Notes_notes__2HjFo","note":"Notes_note__15e1N","markdown":"Notes_markdown__3YCEQ"};